import axios from "axios";

export default class Person {
  constructor() {
    this.base_url = process.env.REACT_APP_URL_PERSON;
    this.name = "/person";
    this.url = this.base_url + this.name;
  }

  grid = async ({ skip = 0, take = 100, active, search, roleIds = [] } = {}) => {
    const params = new URLSearchParams({ skip: String(skip), take: String(take) });
    if (typeof active === "boolean") params.set("active", active ? "1" : "0");
    if (search?.trim()) params.set("search", search.trim());
    if (roleIds.length) params.set("role_ids", roleIds.join(","));
    return await axios.get(`${this.url}?${params.toString()}`);
  };

  getById = async (id) => {
    return await axios.get(`${this.url}/${id}`);
  };

  select = async (options = {}) => {
    const normalized =
      typeof options === "boolean"
        ? { includeConsumidorFinal: options }
        : options;
    const { includeConsumidorFinal, search, roleIds = [] } = normalized;
    const params = new URLSearchParams();
    if (includeConsumidorFinal) params.set("includeConsumidorFinal", "1");
    if (search?.trim()) params.set("search", search.trim());
    if (roleIds.length) params.set("role_ids", roleIds.join(","));
    const query = params.toString();
    return await axios.get(`${this.url}/select${query ? `?${query}` : ""}`);
  };

  create = async (payload) => {
    return await axios.post(this.url, payload);
  };

  update = async (id, payload) => {
    await axios.put(`${this.url}/${id}`, payload);
  };

  updateRoles = async (id, roleIds) => {
    await axios.put(`${this.url}/${id}/roles`, { role_ids: roleIds });
  };

  changeActive = async (id) => {
    await axios.patch(`${this.url}/${id}`);
  };
}
